import { render, staticRenderFns } from "./Highlight.vue?vue&type=template&id=200abd5b&"
import script from "./Highlight.vue?vue&type=script&lang=js&"
export * from "./Highlight.vue?vue&type=script&lang=js&"
import style0 from "./Highlight.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports